var consumer = {};
module.exports = consumer;